import { Component, Element, State, Prop, h, Event, EventEmitter, Method } from '@stencil/core';

import { clickOnElementOrChild } from '../../utils/';

@Component({
  tag: 'zpr-dropdown'
})

export class ZprDropdown {

  @Element() el: HTMLElement;

  @State() isOpen: boolean = false;

  @State() pages: HTMLElement[] = [];

  @State() activePage: string;

  @Prop({reflect: true}) direction? = 'bottom-left';

  @Prop({reflect: true}) size? = 'basic';

  @Event({
    eventName: 'openStatus',
    composed: true,
    cancelable: true,
    bubbles: true,
  }) openStatus: EventEmitter<boolean>;

  componentWillLoad() {
    this.pages = Array.from(this.el.querySelectorAll(':scope > [page]'))
    this.reset()
  }

  componentDidLoad(){
    const toggleEl = this.el.querySelector('[slot="toggle"]');
    toggleEl?.addEventListener('click', (ev: Event) => {
      ev.preventDefault()
      this.toggle()
    })

    const pageLinks = this.el.querySelectorAll('[gotoPage]');
    pageLinks.forEach(pageLink => {
      pageLink.addEventListener('click', () => {
        this.gotoPage(pageLink.getAttribute('gotoPage'))
        // const currActive = this.el.querySelector('.active')
        // currActive.classList.remove('active')
        // const goToPageAtr = pageLink.getAttribute('gotoPage')
        // this.pages[goToPageAtr].classList.add('active')
      })
    })

    document.addEventListener('click', e => {
      if(this.isOpen) {
        if(clickOnElementOrChild(this.el, e)) return
        this.close()
      }
    })
  }

  @Method()
  async open() {
    this.isOpen = true;
    if(this.pages.length >= 1) {
      this.gotoPage(this.pages[0].getAttribute('slot'))
    } else {
      this.gotoPage('body')
    }
    this.openStatus.emit(true);
    // const firstPage = this.el.querySelector('[slot="page0"]');
    // firstPage.classList.add('active');
  }

  @Method()
  async close() {
    this.isOpen = false;
    this.reset()
    this.openStatus.emit(false);
  }

  @Method()
  async toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  gotoPage(id: string) {
    const page = this.el.querySelector(`[slot='${id}']`)

    // remove current active class
    const activeEls = this.el.querySelectorAll('.active')
    activeEls.forEach(activeEl => {
      if(activeEl.classList.contains('active')) {
        activeEl.classList.remove('active')
      }
    })
    this.resetDatepickerInputDropdown()

    // add active class
    page.classList.add('active')
    this.activePage = id;
  }

  reset() {
    // this.activePage = this.pages[0].getAttribute('slot')
    const currActive = this.el.querySelector('.active')
    if(currActive) {
      currActive.classList.remove('active')
    }
    this.activePage = null;
  }

  resetDatepickerInputDropdown() {
    const activeEls = document.querySelectorAll(`zpr-datepicker[slot='body'].active`)
    activeEls.forEach(activeEl => {
      if(activeEl.classList.contains('active')) {
        activeEl.classList.remove('active')
      }
    })
  }

  hostData() {
    return {
      'open': this.isOpen
    }
  }

  renderPage(id: string) {
    return <slot name={id}/>
  }

  render() {
    let pageList = this.pages.map(page => {
      const pageId = page.getAttribute('slot')

      return this.renderPage(pageId)
    })

    return pageList
  }
}
